module.exports = __webpack_public_path__ + "static/projet-04454e17965715e9fd60a535b70e40b9.jpg";